import Icon from '$store/components/ui/Icon.tsx'
import { useSignal } from '@preact/signals'
import { useEffect } from 'preact/hooks'

function BackToTopButton() {
	const hasScrolled = useSignal(false)

	function onScroll() {
		hasScrolled.value = self.scrollY > 200
	}

	// function onClick() {
	// 	self.scrollTo({ top: 0, behavior: 'smooth' })
	// }

	useEffect(() => {
		self.addEventListener('scroll', onScroll)
		return () => self.removeEventListener('scroll', onScroll)
	}, [])

	return (
		<div
			class={`flex items-center justify-center ml-1 bg-white rounded-[5px] w-[41px] max-w-[41px] h-[41px] max-h-[41px] shadow-[2px_2px_5px_0px_rgba(0,0,0,0.15)] transition-all ${
				hasScrolled.value ? 'opacity-100' : 'opacity-0'
			}`}
		>
			<a href='#top'>
				<Icon id='SetaCima' size={24} class='ml-[13px] text-[#252525]' />
				<span class='sr-only'>Voltar para o topo</span>
			</a>
		</div>
	)
}

export default BackToTopButton
